import React, { Component } from "react";
import { Modal, Button, Icon } from "antd";

class ModalPaidStatus extends Component {
  state = {
    visible: true
  };
  componentWillUnmount() {
    this.setState(() => ({
      visible: false
    }));
  }
  render() {
    const { history } = this.props;
    return (
      <Modal
        title={
          <div>
            <Icon
              type="question-circle"
              style={{
                color: "var(--color-yellow-com)",
                fontSize: "2rem",
                marginRight: "1rem"
              }}
            />AS Xpert
          </div>
        }
        visible={this.state.visible}
        closable={false}
        footer={null}
        width={300}
        zIndex={1100}
      >
        <span style={{ display: "flex" }}>
          Para poder continuar es necesario realizar tu pago, gracias.
        </span>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            paddingTop: "1rem"
          }}
        >
          <Button type="primary" onClick={() => history.goBack()}>
            OK
          </Button>
        </div>
      </Modal>
    );
  }
}

export default ModalPaidStatus;



// WEBPACK FOOTER //
// ./src/Components/Orders/ModalPaidStatus.js